import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialState = {
  // Persisted: { [kbId]: { [cardName]: true } }
  // Survives page refresh - dismissed cards hide instantly on next visit
  dismissedByKbId: {},
  // Session-only (not persisted via partialize): tracks which kbIds were fetched this session
  fetchedKbIds: {},
};

const slice = (set) => ({
  ...initialState,
  setFetchedCards: (kbId, data) =>
    set((state) => ({
      dismissedByKbId: {
        ...state.dismissedByKbId,
        [kbId]: { ...(state.dismissedByKbId[kbId] || {}), ...data },
      },
      fetchedKbIds: { ...state.fetchedKbIds, [kbId]: true },
    })),
  dismissCard: (kbId, cardName) =>
    set((state) => ({
      dismissedByKbId: {
        ...state.dismissedByKbId,
        [kbId]: { ...(state.dismissedByKbId[kbId] || {}), [cardName]: true },
      },
    })),
});

export const useExplainerCardsStore = create(
  persist(slice, {
    name: 'explainer-cards',
    // Only persist dismissed state - fetchedKbIds resets each session
    // so we always do one fresh API call per kbId per session
    partialize: (state) => ({ dismissedByKbId: state.dismissedByKbId }),
  })
);
